import { render } from "./CustomHintsGrid.vue?vue&type=template&id=6a521454&scoped=true&ts=true"
import script from "./CustomHintsGrid.vue?vue&type=script&lang=ts"
export * from "./CustomHintsGrid.vue?vue&type=script&lang=ts"

import "./CustomHintsGrid.vue?vue&type=style&index=0&id=6a521454&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a521454"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
